import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "ib-title" }, "Payments", -1)
const _hoisted_2 = {
  key: 0,
  class: "ib-form"
}
const _hoisted_3 = {
  key: 0,
  class: "payment-option"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Pay now", -1)
const _hoisted_5 = { class: "balance-due" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "ib-form" }
const _hoisted_8 = {
  key: 0,
  class: "warning"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  class: "flex center",
  style: {"height":"25px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_currency = _resolveComponent("currency")!
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_info_box = _resolveComponent("info-box")!

  return (_openBlock(), _createBlock(_component_info_box, {
    isActive: _ctx.isActive,
    onOnEdit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('onEdit'))),
    canEdit: false
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      (!_ctx.appMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.activeOrder.orderTotal != 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                  _createElementVNode("li", {
                    class: _normalizeClass(["flex-row flex-justify-sb", { payOpt: _ctx.paymentOption == 'now' }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.paymentOption = 'now'))
                  }, [
                    _hoisted_4,
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_currency, {
                        amount: _ctx.activeOrder.balance
                      }, null, 8, ["amount"])
                    ])
                  ], 2),
                  _createElementVNode("li", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paymentOption = 'later')),
                    class: _normalizeClass({ payOpt: _ctx.paymentOption == 'later' })
                  }, "Pay later", 2)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "action-btn btn-highlight",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onNext()))
            }, _toDisplayString(_ctx.activeOrder.balance ? 'Next' : 'Complete'), 1)
          ]))
        : (!_ctx.isLoading && _ctx.activeOrder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.retry)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Your card has been charged, but the booking failed to complete. If retrying below does not work, please ask an employee for assistance."))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "prog-btn action-btn-themed fw-medium",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('onPayment')))
                }, _toDisplayString(_ctx.retry ? 'Retry save' : _ctx.activeOrder.paid ? 'Book now' : 'Pay now'), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_loader_display, { small: true })
              ])
            ]))
    ]),
    _: 1
  }, 8, ["isActive"]))
}